import { type UseModalState } from "@clipboard-health/ui-components";
import { FullScreenDialog } from "@src/appV2/lib";

import { RestrictedAccountContent } from "./RestrictedAccountContent";

interface RestrictedBottomSheetProps {
  readonly modalState: UseModalState;
  readonly isFinalRestriction: boolean;
  readonly liftTime?: string;
  readonly reEnrollmentScore: number;
  readonly onContinue: () => void;
}

export function RestrictedBottomSheet(props: RestrictedBottomSheetProps) {
  const { modalState, isFinalRestriction, liftTime, reEnrollmentScore, onContinue } = props;

  return (
    <FullScreenDialog
      modalState={modalState}
      variant="tertiary"
      PaperProps={{
        sx: {
          background:
            "linear-gradient(180deg, rgba(251, 242, 232, 1) 0%, rgba(247, 208, 208, 1) 100%)",
        },
      }}
    >
      <RestrictedAccountContent
        enableViewAnalytics={modalState.modalIsOpen}
        isFinalRestriction={isFinalRestriction}
        liftTime={liftTime}
        reEnrollmentScore={reEnrollmentScore}
        onContinue={onContinue}
      />
    </FullScreenDialog>
  );
}
